import { Form, Head } from "@inertiajs/react"

import HeadingSmall from "@/components/heading-small"
import InputError from "@/components/input-error"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AppLayout from "@/layouts/app-layout"
import {
  editEmailSignaturePath,
  emailSignaturePath,
  emailSignaturesPath,
} from "@/routes"
import type { BreadcrumbItem } from "@/types"
import type { EmailSignature } from "@/types"

interface SignaturesEditProps {
  signature: EmailSignature
}

export default function SignaturesEdit({ signature }: SignaturesEditProps) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Email Signatures", href: emailSignaturesPath() },
    { title: "Edit", href: editEmailSignaturePath(signature.id) },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Edit Signature" />

      <div className="flex-1 md:max-w-2xl">
        <section className="max-w-xl space-y-12">
          <div className="p-6">
            <div className="space-y-6">
              <HeadingSmall
                title="Edit Signature"
                description="Update this email signature"
              />

              <Form
                method="put"
                action={emailSignaturePath(signature.id)}
                className="space-y-6"
              >
                {({ processing, errors }) => (
                  <>
                    <div className="grid gap-2">
                      <Label htmlFor="text">Signature Text</Label>
                      <Input
                        id="text"
                        name="email_signature[text]"
                        type="text"
                        required
                        defaultValue={signature.text}
                        placeholder="with love, Alfred"
                      />
                      <p className="text-muted-foreground text-xs">
                        This will appear at the end of notification emails
                      </p>
                      <InputError messages={errors["email_signature.text"]} />
                    </div>

                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        id="active"
                        name="email_signature[active]"
                        value="true"
                        defaultChecked={signature.active}
                        className="h-4 w-4 rounded border-gray-300"
                      />
                      <Label htmlFor="active" className="text-sm font-normal">
                        Active (included in random selection)
                      </Label>
                    </div>

                    <div className="flex gap-4">
                      <Button
                        type="button"
                        variant="outline"
                        onClick={() => history.back()}
                      >
                        Cancel
                      </Button>
                      <Button type="submit" disabled={processing}>
                        {processing && <Spinner />}
                        Save Changes
                      </Button>
                    </div>
                  </>
                )}
              </Form>
            </div>
          </div>
        </section>
      </div>
    </AppLayout>
  )
}
